import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHead, Btn, Card, Field, AiCopyButton, AiSeoButton, SeoPreview } from "@/admin/ui";
import { toast } from "sonner";

const empty = () => ({ title: "", slug: "", heading: "", body: "", seo: {} });

const PagesAdmin = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/admin/pages").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const up = (k, v) => setEditing((e) => ({ ...e, [k]: v }));

  const save = async () => {
    try {
      if (editing.id) await api.put(`/admin/pages/${editing.id}`, editing);
      else await api.post("/admin/pages", editing);
      toast.success("Saved"); setEditing(null); load();
    } catch { toast.error("Failed"); }
  };
  const del = async (id) => { if (!window.confirm("Delete page?")) return; await api.delete(`/admin/pages/${id}`); load(); };

  if (editing) return (
    <div className="max-w-2xl">
      <PageHead title={editing.id ? "Edit Page" : "New Page"}>
        <Btn variant="ghost" onClick={() => setEditing(null)}>Cancel</Btn>
        <Btn onClick={save} testid="admin-save">Save</Btn>
      </PageHead>
      <Card>
        <Field label="Title" value={editing.title} onChange={(v) => up("title", v)} />
        <Field label="Slug" value={editing.slug} onChange={(v) => up("slug", v)} placeholder="auto from title" />
        <Field label="Heading (H1)" value={editing.heading} onChange={(v) => up("heading", v)} />
        <AiCopyButton instruction={`Draft the body copy for the "${editing.title || editing.heading || "new"}" page.`} current={editing.body} onResult={(t) => up("body", t)} testid="page-ai-draft" />
        <Field label="Body" textarea value={editing.body} onChange={(v) => up("body", v)} />
        <AiSeoButton subject={editing.title || editing.heading} context={editing.body} onResult={(d) => up("seo", { ...editing.seo, title: d.title, description: d.description })} testid="page-ai-seo" />
        <Field label="SEO Title" value={editing.seo?.title} onChange={(v) => up("seo", { ...editing.seo, title: v })} />
        <Field label="SEO Description" textarea value={editing.seo?.description} onChange={(v) => up("seo", { ...editing.seo, description: v })} />
        <SeoPreview title={editing.seo?.title} description={editing.seo?.description} path={`/pages/${editing.slug || ""}`} />
      </Card>
    </div>
  );

  return (
    <div>
      <PageHead title="Pages" sub={`${items.length} pages`}>
        <Btn onClick={() => setEditing(empty())} testid="admin-new-page">+ New Page</Btn>
      </PageHead>
      <div className="bg-cream border border-espresso/10">
        {items.map((p) => (
          <div key={p.id} className="flex items-center gap-4 px-5 py-3 border-b border-espresso/5">
            <div className="flex-1">
              <p className="font-serif text-lg">{p.title} <span className="text-xs text-espresso/40">/pages/{p.slug}</span></p>
            </div>
            <Btn variant="ghost" onClick={() => setEditing(p)}>Edit</Btn>
            <button onClick={() => del(p.id)} className="text-wine text-xs tracking-widest uppercase">Delete</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PagesAdmin;
